<template>
  <div>
    <div class="mt-5 text-start padding-box">
      <h4 class="fw-bold" style="color: #265054">
        <router-link
          :to="`/fillin-daily/${location_id}?building=${$route.query.building}`"
          ><img src="@/assets/mobile/arrow-left.svg" alt=""
        /></router-link>
        {{ typeName }}
      </h4>
      <h6 class="mt-2" style="color: #51646b">
        ข้อมูลย้อนหลังสมรรถนะการใช้พลังงาน
        <span class="fw-semibold">และกรุณากรอกข้อมูลตัวเลขปัจจุบัน</span>
      </h6>
      <div class="row">
        <div class="col-12 text-end">
          <p class="mb-0 text-sm">เฉลี่ย : {{ decimalFormat(average) }}</p>
        </div>
      </div>
      <div class="box-graph rounded-3 p-1">
        <LineChart
          v-if="showGraph"
          Name="Task"
          :Color="colorDoughnut"
          :label-graph="labelGraph"
          :DataDoughnut="dataDoughnut"
          :is-tooltip="isTooltip"
          :unit-name="unit_name"
          id="Doughnut"
        />
        <div v-else style="text-align: center">
          <LoadingVue />
        </div>
      </div>
      <div class="mt-4 d-grid">
        <button
          class="btn button-fillin text-white rounded-pill px-4 py-2 fs-3 mx-auto"
          @click="modalAddDetailDaily()"
          :disabled="permissionFillin != true"
        >
          เพิ่มข้อมูล
        </button>
      </div>
      <div class="mt-3 mb-5">
        <div class="d-flex">
          <span class="text-bgreen-200 fw-bold">ประวัติ</span>
        </div>
        <div v-if="data_show_ghg && data_show_ghg.length > 0" class="w-100">
          <div
            v-for="(list, index) in data_show_ghg"
            :key="index"
            class="mt-1 box-detail w-100"
          >
            <div class="d-flex w-100">
              <div style="font-weight: 700">
                {{ formatThaiDate(list.date) }}
              </div>
              <div class="ms-auto">
                <button
                  v-if="
                    list.status != 4 ||
                    (list.status == 4 && list.files && list.files.length > 0)
                  "
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src="@/assets/mobile/morevert.png"
                    class="mw-100"
                    alt=""
                  />
                </button>
                <ul
                  class="dropdown-menu text-left p-1 pl-2 cursor-pointer"
                  style="min-width: 6rem !important"
                >
                  <li class="mb-1" @click="modalEditDaily(list)">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M2 11.5V14H4.5L11.8733 6.62669L9.37333 4.12669L2 11.5ZM13.8067 4.69335C14.0667 4.43335 14.0667 4.01335 13.8067 3.75335L12.2467 2.19335C11.9867 1.93335 11.5667 1.93335 11.3067 2.19335L10.0867 3.41335L12.5867 5.91335L13.8067 4.69335Z"
                        fill="#212121"
                      />
                    </svg>
                    แก้ไข
                  </li>
                  <li
                    v-if="list.status === 1 || list.status === 3"
                    class="mb-1"
                    @click="confirmDeleteDetail(list)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      :width="'16'"
                      :height="'16'"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M4.00016 12.6667C4.00016 13.4 4.60016 14 5.3335 14H10.6668C11.4002 14 12.0002 13.4 12.0002 12.6667V4.66667H4.00016V12.6667ZM5.3335 6H10.6668V12.6667H5.3335V6ZM10.3335 2.66667L9.66683 2H6.3335L5.66683 2.66667H3.3335V4H12.6668V2.66667H10.3335Z"
                        :fill="'#212121'"
                      />
                    </svg>
                    ลบข้อมูล
                  </li>
                  <li
                    v-if="
                      list.files &&
                      list.files.length > 0 &&
                      checkOnlyImage(list.files[0]) == false
                    "
                    class="mb-1"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-file-earmark-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"
                      />
                    </svg>
                    <a
                      v-if="list.files && list.files.length > 0"
                      :href="list.files[0].file.file_url"
                      target="_blank"
                      class="ms-2 w-75 text-dark"
                      style="text-decoration: none"
                      >Download
                    </a>
                  </li>
                  <li
                    v-if="
                      list.files &&
                      list.files.length > 0 &&
                      checkOnlyImage(list.files[0])
                    "
                    @click="showPicture(list)"
                    class="mb-1"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-file-earmark-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"
                      />
                    </svg>
                    <span class="ms-2 w-75">ดูเอกสาร</span>
                  </li>
                  <li
                    v-if="
                      list.files &&
                      list.files.length > 0 &&
                      checkOnlyImage(list.files[0])
                    "
                    class="mb-1"
                    @click="deleteImage(list)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-trash mr-2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                      />
                    </svg>
                    <span class="ms-2 w-75">ลบเอกสาร</span>
                  </li>
                  <li
                    v-if="
                      list.files &&
                      list.files.length > 0 &&
                      checkOnlyImage(list.files[0]) == false
                    "
                    class="mb-1"
                    @click="deleteImage(list)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-trash mr-2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                      />
                    </svg>
                    <span class="ms-2 w-75">ลบไฟล์</span>
                  </li>
                </ul>
              </div>
            </div>
            <div
              v-if="
                measureById && measureById.item && measureById.item.format == 3
              "
              class="row mt-1"
            >
              <div class="col-4">
                ค่า {{ list.water_report == 1 ? "BOD" : "COD" }}
                <span v-if="list && list.wastewater_treatment_system_type == 2"
                  >ท่อน้ำเข้า</span
                >:
              </div>
              <div class="col-4 text-end">
                {{ list ? list.amount_of_entry.toLocaleString("en-US") : "-" }}
              </div>
              <div class="col-4 text-end">
                mg/L
                <!-- {{
                  list.measure_list && list.measure_list.unit
                    ? list.measure_list.unit.name_en
                    : "-"
                }} -->
              </div>
            </div>
            <div
              v-if="
                list &&
                list.wastewater_treatment_system_type == 2 &&
                measureById &&
                measureById.item &&
                measureById.item.format == 3
              "
              class="row mt-1"
            >
              <div class="col-4">
                ค่า {{ list.water_report == 1 ? "BOD" : "COD" }} ท่อน้ำออก:
              </div>
              <div class="col-4 text-end">
                {{ list ? list.amount_of_out.toLocaleString("en-US") : "-" }}
              </div>
              <div class="col-4 text-end">
                mg/L
                <!-- {{
                  list.measure_list && list.measure_list.unit
                    ? list.measure_list.unit.name_en
                    : "-"
                }} -->
              </div>
            </div>
            <div
              v-if="
                measureById && measureById.item && measureById.item.format != 2
              "
              class="row mt-1"
            >
              <div class="col-4">
                ปริมาณ<span
                  v-if="
                    measureById &&
                    measureById.item &&
                    measureById.item.format == 3
                  "
                  >น้ำ</span
                >
                :
              </div>
              <div class="col-4 text-end">
                {{ list ? list.amount.toLocaleString("en-US") : "-" }}
              </div>
              <div class="col-4 text-end">
                <span
                  v-if="
                    measureById &&
                    measureById.item &&
                    measureById.item.format == 3
                  "
                  >L</span
                >
                <span v-else>
                  {{
                    list.measure_list && list.measure_list.unit
                      ? list.measure_list.unit.name_en
                      : "-"
                  }}
                </span>
              </div>
            </div>
            <!-- septic tank -->
            <div
              v-if="
                measureById && measureById.item && measureById.item.format == 2
              "
              class="row mt-1"
            >
              <div class="col-4">จำนวนพนักงาน:</div>
              <div class="col-4 text-end">
                {{ list ? list.amount.toLocaleString("en-US") : "-" }}
              </div>
              <div class="col-4 text-end">คน</div>
            </div>
            <div
              v-if="
                measureById && measureById.item && measureById.item.format == 2
              "
              class="row mt-1"
            >
              <div class="col-4">จำนวนวันทำงาน:</div>
              <div class="col-4 text-end">
                {{ list ? list.quantity.toLocaleString("en-US") : "-" }}
              </div>
              <div class="col-4 text-end">วัน</div>
            </div>
          </div>
        </div>
        <div v-else class="p-5 text-center fw-bold">ไม่พบข้อมูล</div>
      </div>
      <!-- <div class="mt-3 box mb-5" style="max-height: 500px; overflow-y: auto">
        <div class="d-flex">
          <span class="text-bgreen-200 fw-bold">ประวัติ</span>
          <span class="ms-auto text-bgreen-200 fw-bold">{{ unit_name }}</span>
        </div>
        <div v-if="data_show_ghg && data_show_ghg.length > 0">
          <div
            v-for="(list, index) in data_show_ghg"
            :key="index"
            class="mt-1 row"
          >
            <div class="col-6">
              {{ dateTimeTh(list.date) }}
              <span
                v-if="list.reset_amount"
                class="reset-box rounded-pill text-center px-1"
                style="font-size: 0.8em"
                >Reset</span
              >
            </div>
            <div
              class="col-6 text-end flex align-items-center"
              style="font-weight: 500"
            >
              {{
                input_type == 1
                  ? decimalFormat(list.current_amount)
                  : decimalFormat(list.amount)
              }}

              <button
                v-if="
                  list.status != 4 ||
                  (list.status == 4 && list.files && list.files.length > 0)
                "
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img src="@/assets/mobile/morevert.png" class="mw-100" alt="" />
              </button>
              <ul
                class="dropdown-menu text-left p-1 pl-2 cursor-pointer"
                style="min-width: 6rem !important"
              >
                <li class="mb-1" @click="modalEditDaily(list)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M2 11.5V14H4.5L11.8733 6.62669L9.37333 4.12669L2 11.5ZM13.8067 4.69335C14.0667 4.43335 14.0667 4.01335 13.8067 3.75335L12.2467 2.19335C11.9867 1.93335 11.5667 1.93335 11.3067 2.19335L10.0867 3.41335L12.5867 5.91335L13.8067 4.69335Z"
                      fill="#212121"
                    />
                  </svg>
                  แก้ไข
                </li>
                <li
                  v-if="list.status === 1 || list.status === 3"
                  class="mb-1"
                  @click="confirmDeleteDetail(list)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    :width="'16'"
                    :height="'16'"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M4.00016 12.6667C4.00016 13.4 4.60016 14 5.3335 14H10.6668C11.4002 14 12.0002 13.4 12.0002 12.6667V4.66667H4.00016V12.6667ZM5.3335 6H10.6668V12.6667H5.3335V6ZM10.3335 2.66667L9.66683 2H6.3335L5.66683 2.66667H3.3335V4H12.6668V2.66667H10.3335Z"
                      :fill="'#212121'"
                    />
                  </svg>
                  ลบข้อมูล
                </li>
                <li
                  v-if="
                    list.files &&
                    list.files.length > 0 &&
                    checkOnlyImage(list.files[0]) == false
                  "
                  class="mb-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-file-earmark-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"
                    />
                  </svg>
                  <a
                    v-if="list.files && list.files.length > 0"
                    :href="list.files[0].file.file_url"
                    target="_blank"
                    class="ms-2 w-75 text-dark"
                    style="text-decoration: none"
                    >Download
                  </a>
                </li>
                <li
                  v-if="
                    list.files &&
                    list.files.length > 0 &&
                    checkOnlyImage(list.files[0])
                  "
                  @click="showPicture(list)"
                  class="mb-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-file-earmark-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"
                    />
                  </svg>
                  <span class="ms-2 w-75">ดูเอกสาร</span>
                </li>
                <li
                  v-if="
                    list.files &&
                    list.files.length > 0 &&
                    checkOnlyImage(list.files[0])
                  "
                  class="mb-1"
                  @click="deleteImage(list)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                  <span class="ms-2 w-75">ลบเอกสาร</span>
                </li>
                <li
                  v-if="
                    list.files &&
                    list.files.length > 0 &&
                    checkOnlyImage(list.files[0]) == false
                  "
                  class="mb-1"
                  @click="deleteImage(list)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                  <span class="ms-2 w-75">ลบไฟล์</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-else class="p-5 text-center fw-bold">ไม่พบข้อมูล</div>
      </div> -->
    </div>
    <!-- @saveDataDaily="saveDataDaily" -->
    <ModalCreateFillInDaily
      :next-date="dateOnDailyString"
      :reset-form="resetForm"
      :type-modal="typeModal"
      :type-name="typeName"
      :file-name="fileName"
      :data-edit-daily="data_edit"
      :time-now="timeNow"
      :min-date="minDate"
      :max-date="maxDate"
      :unit="unit_name"
      :date-time="date_time"
      :measure-by-id="measureById"
      @saveDataDaily="uploadImage"
      @editDataDaily="uploadImageEdit"
      @showModalAttachReference="showModalAttachReference"
    />

    <ModalAttachReferences
      :img-upload="imgUpload"
      :is-delete-img="isDeleteImg"
      :is-reset-img="isResetImg"
      @openModalCamera="openModalCamera"
      @imageUpload="imageUpload"
    />

    <ModalShowPicture :picture="picture" />

    <ModalCamera
      :is-start-camera="isStartCamera"
      @clearStatusCamera="clearStatusCamera"
      @snapImage="snapImage"
    />

    <ModalConfirm
      :is-trash-icon="true"
      :text-header="text_header"
      :sub-text="sub_text"
      @deleteFile="deleteListDaily"
    />

    <ModalAlertNotFillIn />
  </div>
</template>
<script>
import LineChart from "@/components/echart/LineChart";
import ModalCreateFillInDaily from "@/components/Modal/ModalCreateFillInDaily";
import ModalAttachReferences from "@/components/Modal/ModalAttachReferences";
import ModalShowPicture from "@/components/Modal/ModalShowPicture";
import ModalCamera from "@/components/Modal/ModalCamera";
import ModalConfirm from "@/components/Modal/ModalConfirm";
import ModalAlertNotFillIn from "@/components/Modal/ModalAlertNotFillIn";
import helper from "@/mixins/helper";
import { httpClient } from "@/token/axios.js";
import axios from "axios";
import { apiURL } from "@/configs/serverConfig";
import LoadingVue from "@/components/LoadingMask.vue";
import store from "@/store";
import moment from "moment";

export default {
  components: {
    LineChart,
    ModalCreateFillInDaily,
    ModalAlertNotFillIn,
    LoadingVue,
    ModalAttachReferences,
    ModalCamera,
    ModalShowPicture,
    ModalConfirm,
  },
  mixins: [helper],
  data() {
    return {
      showGraph: false,
      colorDoughnut: [],
      labelGraph: [],
      dataDoughnut: [],
      ghg_id: null,
      ghg_list: null,
      data_show_ghg: null,
      resetForm: false,
      dateOnDailyString: null,
      typeName: "",
      roleUser: "",
      lastDate: "",
      isFillin: false,
      location_id: "",
      typeModal: "",
      lastListDaily: "", // ข้อมูลวันล่าสุด
      // companyId: "",
      ghgLists: "",
      filter_type: 0,
      isStartCamera: false,
      imgUpload: null,
      fileImageUpload: null, //file upload
      responseFileUpload: null,
      dataUploadDaily: null,
      picture: null,
      valueEditData: 0,
      average: 0,
      fileName: null,
      isTooltip: false,
      dataEditDaily: null,
      isDeleteImg: false,
      input_type: null,
      isResetImg: false,
      timeNow: null,
      frequency_type: null,
      minDate: null,
      maxDate: null,
      unit_name: null,
      permissionFillin: this.$store.state.permissions.filling_out.access,
      date_time: "",
      measureById: null,
      data_edit: null,
      text_header: null,
      sub_text: null,
      data_row: null,
    };
  },
  async created() {
    this.location_id = this.$route.params.location_id;
    this.ghg_id = this.$route.params.id;
    this.input_type = this.$route.query.input_type;
    this.frequency_type = this.$route.query.frequency_type;
    this.typeName = this.$route.query.name;
    this.unit_name = this.$route.query.unit;
    await this.getMeasureListById();
    await this.getGhgLists();
  },
  methods: {
    async getGhgLists() {
      this.isTooltip = true;
      this.getHistory();
      this.showGraph = false;
      this.labelGraph = [];
      this.dataDoughnut = [];
      this.dateOnDailyString = null;
      // const url = `${apiURL}/location/ghg/list?ghg_id=${this.ghg_id}&location_id=${this.location_id}&unit=${this.filter_type}&limit=30`;

      const url = `${apiURL}/measure_list_history?page=1&size=30&measure_list_id=${this.ghg_id}&sort=measure_list_histories.date`;

      try {
        const ghgLists = await httpClient.get(url);
        this.ghg_list = ghgLists.data.entities;

        const _data = {
          type: "line",
          name: this.typeName,
          data: [],
          markLine: {
            data: [
              {
                type: "average",
                name: "Avg",
                label: {
                  position: "end",
                  formatter: "เฉลี่ย",
                  fontFamily: "Kanit",
                },
              },
            ],
          },
        };
        let sum_value = 0;
        for (let list of this.ghg_list) {
          let value = null;
          if (this.measureById.item.format == 1) {
            value = list.amount;
          } else if (this.measureById.item.format == 2) {
            value = list.kg_ch4_amount;
          } else {
            value = list.kg_ch4_amount;
          }

          sum_value = sum_value + value;
          // let onlyDate = list.date.split("T")[0];
          this.labelGraph.push(this.formatThaiDate(list.date));
          _data.data.push([
            this.formatThaiDate(list.date),
            this.decimalNotRounded(value),
          ]);
        }

        this.average =
          this.ghg_list.length > 0 ? sum_value / this.ghg_list.length : 0;

        this.dataDoughnut.push(_data);
        this.showGraph = true;
      } catch (err) {
        console.log(err);
      }
    },
    async getMeasureListById() {
      const url = `${apiURL}/measure_list/${this.ghg_id}`;

      try {
        const measureById = await httpClient.get(url);
        this.measureById = measureById.data;
      } catch (err) {
        this.$toast.error({
          component: "styled-toast",
          props: {
            type: "error",
            message: err.response.data.message,
          },
        });
      }
    },
    async modalAddDetailDaily() {
      this.isResetImg = !this.isResetImg;
      this.imgUpload = null;
      this.fileName = null;
      this.fileImageUpload = null;
      this.responseFileUpload = null;
      this.lastDate = this.isFillin
        ? this.data_show_ghg[0].date
        : this.$route.query.start_fillin;
      this.typeModal = "create";
      this.resetForm = true;
      this.timeNow = this.getTimeNow();
      this.getDateTimeFilledIn();
      await this.getGhgLists();
      this.$bvModal.show("modal-add-detail-daily");
      // if (this.frequency_type == 0) {
      //   this.checkFillinDay();
      // } else if (this.frequency_type == 1) {
      //   this.checkFillinMonth();
      // } else if (this.frequency_type == 2) {
      //   this.checkFillinYear();
      // }
    },

    async modalEditDaily(data) {
      this.fileName =
        data.files && data.files.length > 0 ? data.files[0].file.name : null;
      this.imgUpload =
        data.files && data.files.length > 0 ? data.files[0] : null;
      this.responseFileUpload =
        data.files && data.files.length > 0 ? data.files[0] : null;
      this.data_edit = data;
      this.typeModal = "edit";
      this.resetForm = true;
      this.getDateTimeFilledIn();
      await this.getGhgLists();
      this.$bvModal.show("modal-add-detail-daily");
    },

    checkFillinDay() {
      if (this.isFillin) {
        // เคยกรอกข้อมูลแล้ว

        if (
          new Date(moment(Date.now()).format().split("T")[0]).getTime() -
            new Date(this.lastDate.split("T")[0]).getTime() >
          0
        ) {
          this.dateOnDailyString = moment(this.lastDate).add(1, "days");
          this.$bvModal.show("modal-add-detail-daily");
        } else {
          // this.$toast.error('ไม่อนุญาตให้กรอกข้อมูลล่วงหน้า')
          this.$bvModal.show("modal-alert-not-fillin");
        }
      } else {
        if (Date.now() - new Date(this.lastDate).getTime() >= 0) {
          this.dateOnDailyString = moment(this.lastDate).format("YYYY-MM-DD");
          this.$bvModal.show("modal-add-detail-daily");
        } else {
          this.$bvModal.show("modal-alert-not-fillin");
        }
      }
    },

    checkFillinMonth() {
      if (this.isFillin) {
        let dateNow = new Date();

        let onePlusMonth = moment(this.lastDate).add(1, "M");
        // let onePlusMonthCheck = new Date(onePlusMonth).getTime();
        let onePlusMonthCheck = new Date(
          `${onePlusMonth._d.getFullYear()}-${String(
            onePlusMonth._d.getMonth() + 1
          ).padStart(2, "0")}-01`
        ).getTime();

        let checkMonthNow = new Date().getTime();

        if (checkMonthNow - onePlusMonthCheck >= 0) {
          const d = new Date(onePlusMonthCheck);
          let lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
          let splitLastDateOfMonth = String(lastDay.getDate()).padStart(2, "0");

          this.minDate = moment(
            new Date(d.getFullYear(), d.getMonth(), 1)
          ).format("YYYY-MM-DD");
          this.maxDate = moment(
            new Date(d.getFullYear(), d.getMonth() + 1, 0)
          ).format("YYYY-MM-DD");

          let setYear = String(d.getFullYear());
          if (setYear.length < 4) {
            let length = 4 - setYear.length;
            for (let i = 0; i < length; i++) {
              setYear = `0${setYear}`;
            }

            // วันที่ถ้าเกิดวันที่ปัจจุบันเลยวันที่สุดท้ายของเดือนกรอกข้อมูลย้อนหลังจะให้ใช้วันที่สุดท้ายของเดือนนั้นๆ
            this.dateOnDailyString = `${setYear}-${String(
              d.getMonth() + 1
            ).padStart(2, "0")}-${
              String(dateNow.getDate()).padStart(2, "0") -
                splitLastDateOfMonth >=
              1
                ? splitLastDateOfMonth
                : String(dateNow.getDate()).padStart(2, "0")
            }`;
          } else {
            this.dateOnDailyString = `${String(d.getFullYear())}-${String(
              d.getMonth() + 1
            ).padStart(2, "0")}-${
              String(dateNow.getDate()).padStart(2, "0") -
                splitLastDateOfMonth >=
              1
                ? splitLastDateOfMonth
                : String(dateNow.getDate()).padStart(2, "0")
            }`;
          }
          this.$bvModal.show("modal-add-detail-daily");
        } else {
          this.$bvModal.show("modal-alert-not-fillin");
        }
      } else {
        let dateNow = new Date();
        let startFillinDateCheck = new Date(this.lastDate).getTime();
        let checkMonthNow = new Date().getTime();

        if (checkMonthNow - startFillinDateCheck >= 0) {
          const d = new Date(this.lastDate);
          let lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
          let splitLastDateOfMonth = String(lastDay.getDate()).padStart(2, "0");

          this.minDate = moment(
            new Date(d.getFullYear(), d.getMonth(), 1)
          ).format("YYYY-MM-DD");
          this.maxDate = moment(
            new Date(d.getFullYear(), d.getMonth() + 1, 0)
          ).format("YYYY-MM-DD");
          let setYear = String(d.getFullYear());
          if (setYear.length < 4) {
            let length = 4 - setYear.length;
            for (let i = 0; i < length; i++) {
              setYear = `0${setYear}`;
            }
            this.dateOnDailyString = `${setYear}-${String(
              d.getMonth() + 1
            ).padStart(2, "0")}-${
              String(dateNow.getDate()).padStart(2, "0") -
                splitLastDateOfMonth >=
              1
                ? splitLastDateOfMonth
                : String(dateNow.getDate()).padStart(2, "0")
            }`;
          } else {
            this.dateOnDailyString = `${String(d.getFullYear())}-${String(
              d.getMonth() + 1
            ).padStart(2, "0")}-${
              String(dateNow.getDate()).padStart(2, "0") -
                splitLastDateOfMonth >=
              1
                ? splitLastDateOfMonth
                : String(dateNow.getDate()).padStart(2, "0")
            }`;
          }
          this.$bvModal.show("modal-add-detail-daily");
        } else {
          this.$bvModal.show("modal-alert-not-fillin");
        }
      }
    },
    // checkFillinMonth() {
    //   if (this.isFillin) {
    //     let dateNow = new Date();

    //     let onePlusMonth = moment(this.lastDate).add(1, "M");
    //     let onePlusMonthCheck = new Date(
    //       `${onePlusMonth._d.getFullYear()}-${String(
    //         onePlusMonth._d.getMonth() + 1
    //       ).padStart(2, "0")}-01`
    //     ).getTime();
    //     let checkMonthNow = new Date().getTime();

    //     if (checkMonthNow - onePlusMonthCheck >= 0) {
    //       const d = new Date(onePlusMonthCheck);
    //       this.minDate = moment(
    //         new Date(d.getFullYear(), d.getMonth(), 1)
    //       ).format("YYYY-MM-DD");
    //       this.maxDate = moment(
    //         new Date(d.getFullYear(), d.getMonth() + 1, 0)
    //       ).format("YYYY-MM-DD");

    //       this.dateOnDailyString = `${d.getFullYear()}-${String(
    //         d.getMonth() + 1
    //       ).padStart(2, "0")}-${String(dateNow.getDate()).padStart(2, "0")}`;

    //       this.$bvModal.show("modal-add-detail-daily");
    //     } else {
    //       this.$bvModal.show("modal-alert-not-fillin");
    //     }
    //   } else {
    //     let dateNow = new Date();
    //     let startFillinDateCheck = new Date(this.lastDate).getTime();
    //     let checkMonthNow = new Date().getTime();

    //     if (checkMonthNow - startFillinDateCheck >= 0) {
    //       const d = new Date(this.lastDate);
    //       this.minDate = moment(
    //         new Date(d.getFullYear(), d.getMonth(), 1)
    //       ).format("YYYY-MM-DD");
    //       this.maxDate = moment(
    //         new Date(d.getFullYear(), d.getMonth() + 1, 0)
    //       ).format("YYYY-MM-DD");

    //       this.dateOnDailyString = `${d.getFullYear()}-${String(
    //         d.getMonth() + 1
    //       ).padStart(2, "0")}-${String(dateNow.getDate()).padStart(2, "0")}`;

    //       this.$bvModal.show("modal-add-detail-daily");
    //     } else {
    //       this.$bvModal.show("modal-alert-not-fillin");
    //     }
    //   }
    // },

    checkFillinYear() {
      if (this.isFillin) {
        let dateNow = new Date();
        let onePlusYear = moment(this.lastDate).add(1, "Y");

        // let onePlusYearCheck = new Date(onePlusYear).getTime();
        let onePlusYearCheck = new Date(onePlusYear).getTime(
          `${onePlusYear._d.getFullYear()}-01-01`
        );
        let checkYearNow = new Date().getTime();

        if (checkYearNow - onePlusYearCheck >= 0) {
          const d = new Date(onePlusYearCheck);
          this.minDate = moment(new Date(d.getFullYear(), 0, 1)).format(
            "YYYY-MM-DD"
          );

          this.maxDate = moment(new Date(d.getFullYear() + 1, 0, 0)).format(
            "YYYY-MM-DD"
          );

          this.dateOnDailyString = `${d.getFullYear()}-${String(
            dateNow.getMonth() + 1
          ).padStart(2, "0")}-${String(dateNow.getDate()).padStart(2, "0")}`;

          this.$bvModal.show("modal-add-detail-daily");
        } else {
          this.$bvModal.show("modal-alert-not-fillin");
        }
      } else {
        let dateNow = new Date();
        let startFillinDateCheck = moment(this.lastDate).format("YYYY-MM-DD");
        let checkYearNow = moment(new Date()).format("YYYY-MM-DD");

        if (startFillinDateCheck.split("-")[0] <= checkYearNow.split("-")[0]) {
          const d = new Date(this.lastDate);
          this.minDate = moment(new Date(d.getFullYear(), 0, 1)).format(
            "YYYY-MM-DD"
          );
          this.maxDate = moment(new Date(d.getFullYear() + 1, 0, 0)).format(
            "YYYY-MM-DD"
          );

          this.dateOnDailyString = `${d.getFullYear()}-${String(
            dateNow.getMonth() + 1
          ).padStart(2, "0")}-${String(dateNow.getDate()).padStart(2, "0")}`;

          this.$bvModal.show("modal-add-detail-daily");
        } else {
          this.$bvModal.show("modal-alert-not-fillin");
        }
      }
    },

    async saveDataDaily(data) {
      const url = `${apiURL}/measure_list_history`;
      let _data = null;
      if (this.measureById.item.format == 1) {
        // normal
        _data = {
          measure_list_id: parseInt(this.ghg_id),
          amount: parseInt(data.amount.replace(/,/g, ""), 10),
          date: moment(data.datePicker).format(),
          file_ids: this.responseFileUpload
            ? [parseInt(this.responseFileUpload.id)]
            : null,
          comment: data.comment ? data.comment : null,
          status: 1,
        };
      } else if (this.measureById.item.format == 2) {
        //septictank
        _data = {
          measure_list_id: parseInt(this.ghg_id),
          amount: parseInt(data.number_of_employee.replace(/,/g, ""), 10),
          quantity: parseInt(data.quantity.replace(/,/g, ""), 10),
          date: moment(data.datePicker).format(),
          file_ids: this.responseFileUpload
            ? [parseInt(this.responseFileUpload.id)]
            : null,
          comment: data.comment ? data.comment : null,
          status: 1,
        };
      } else {
        _data = {
          measure_list_id: parseInt(this.ghg_id),
          amount: parseInt(data.water_quantity.replace(/,/g, ""), 10),
          date: moment(data.datePicker).format(),
          file_ids: this.responseFileUpload
            ? [parseInt(this.responseFileUpload.id)]
            : null,
          comment: data.comment ? data.comment : null,
          status: 1,
          // wastewater_treatment_type: data.wastewater_treatment_type,
          wastewater_treatment_system_type: parseInt(data.type_of_waste_water),
          water_report: parseInt(data.water_reporting),
          amount_of_entry: parseInt(data.bod_water_inlet.replace(/,/g, ""), 10), //ค่า bod
          amount_of_out:
            data.type_of_waste_water == 2
              ? parseInt(data.bod_water_outlet.replace(/,/g, ""), 10)
              : null,
        };
      }
      try {
        const addDataDaily = await httpClient.post(url, _data);
        if (addDataDaily.status == 200) {
          this.getGhgLists();
          this.getHistory();
          this.$toast.success("บันทึกสำเร็จ");
          this.$nextTick(() => {
            this.$bvModal.hide("modal-add-detail-daily");
            this.resetForm = false;
          });
        }
      } catch (err) {
        console.log("errr", err);
        this.$toast.error(err.response.data.message);
        this.$nextTick(() => {
          this.resetForm = false;
          this.$bvModal.hide("modal-add-detail-daily");
        });
      }
    },

    async modalEditDetailDaily(data, index) {
      this.isResetImg = !this.isResetImg;
      this.fileName = null;
      this.fileImageUpload = null;
      this.imgUpload = null;
      this.resetForm = true;

      await this.getGhgLists();
      this.dataEditDaily = data;
      this.responseFileUpload =
        data.files && data.files[0] ? data.files[0] : null;
      this.imgUpload = data.files && data.files[0] ? data.files[0] : null;

      this.typeModal = "edit";
      this.lastListDaily = this.data_show_ghg[index];
      this.dateOnDailyString = this.data_show_ghg[index].date;
      this.timeNow = this.timeThai(this.lastListDaily.date);
      this.$bvModal.show("modal-add-detail-daily");
    },

    async editDataDaily(data) {
      const url = `${apiURL}/measure_list_history`;

      let _data = null;
      if (this.measureById.item.format == 1) {
        // normal
        _data = {
          id: this.data_edit.id,
          // amount: Number(data.amount),
          amount: parseInt(data.amount.replace(/,/g, ""), 10),
          date: moment(data.datePicker).format(),
          file_ids: this.responseFileUpload
            ? this.responseFileUpload.file_id
              ? [parseInt(this.responseFileUpload.file_id)]
              : [parseInt(this.responseFileUpload.id)]
            : null,
          comment: data.comment ? data.comment : null,
          status: 1,
        };
      } else if (this.measureById.item.format == 2) {
        //septictank
        _data = {
          id: this.data_edit.id,
          amount: parseInt(data.number_of_employee.replace(/,/g, ""), 10),
          quantity: parseInt(data.quantity.replace(/,/g, ""), 10),
          // amount: Number(data.number_of_employee),
          // quantity: Number(data.quantity),
          date: moment(data.datePicker).format(),
          file_ids: this.responseFileUpload
            ? this.responseFileUpload.file_id
              ? [parseInt(this.responseFileUpload.file_id)]
              : [parseInt(this.responseFileUpload.id)]
            : null,
          comment: data.comment ? data.comment : null,
          status: 1,
        };
      } else {
        _data = {
          id: this.data_edit.id,
          amount: parseInt(data.water_quantity.replace(/,/g, ""), 10),
          date: moment(data.datePicker).format(),
          file_ids: this.responseFileUpload
            ? [parseInt(this.responseFileUpload.id)]
            : null,
          comment: data.comment ? data.comment : null,
          status: 1,
          // wastewater_treatment_type: data.wastewater_treatment_type,
          wastewater_treatment_system_type: parseInt(data.type_of_waste_water),
          water_report: parseInt(data.water_reporting),
          amount_of_entry: parseInt(data.bod_water_inlet.replace(/,/g, ""), 10), //ค่า bod
          amount_of_out:
            data.type_of_waste_water == 2
              ? parseInt(data.bod_water_outlet.replace(/,/g, ""), 10)
              : null,
        };
      }
      try {
        const editDailyByList = await httpClient.put(url, _data);
        if (editDailyByList.status == 200) {
          this.getGhgLists();
          this.getHistory();
          this.$toast.success("บันทึกสำเร็จ");
          this.$nextTick(() => {
            this.$bvModal.hide("modal-add-detail-daily");
            this.resetForm = false;
          });
        }
      } catch (err) {
        this.$toast.error(err.response.data.message);
        this.$nextTick(() => {
          this.$bvModal.hide("modal-add-detail-daily");
          this.resetForm = false;
        });
      }
    },

    // async getCompanyId() {
    //   const url = `${apiURL}/company?user_relation=STAY_IN`;

    //   try {
    //     const companyId = await httpClient.get(url);
    //     this.companyId = companyId.data[0].id;
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },

    // async getGHG() {
    //   const url = `${apiURL}/location/ghg?company_id=${this.companyId}`;

    //   try {
    //     const ghgs = await httpClient.get(url);
    //     this.ghgLists = ghgs.data;
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },

    async deleteListDaily() {
      const url = `${apiURL}/measure_list_history/${this.data_row.id}`;

      try {
        const deleteList = await httpClient.delete(url);
        if (deleteList.status == 200) {
          this.getGhgLists();
          this.getHistory();
          this.$bvModal.hide("modal-confirm");
          this.$toast.success("บันทึกสำเร็จ");
        }
      } catch (err) {
        console.log(err);
      }
      this.resetForm = false;
    },

    async getHistory() {
      // const url = `${apiURL}/location/ghg/list/history?ghg_id=${this.ghg_id}&limit=30&location_id=${this.location_id}&unit=${this.filter_type}`;

      const url = `${apiURL}/measure_list_history?page=1&size=30&measure_list_id=${this.ghg_id}`;
      try {
        const history = await httpClient.get(url);
        this.data_show_ghg = history.data.entities;
        //เช็คว่าเคยกรอกข้อมูลหรือยัง
        if (this.data_show_ghg && this.data_show_ghg.length > 0) {
          this.isFillin = true;
        }
      } catch (err) {
        console.log(err);
      }
    },

    openModalCamera() {
      // this.$bvModal.hide("modal-attach-reference");
      this.isStartCamera = true;
      this.$bvModal.show("modal-camera");
    },

    clearStatusCamera() {
      this.isStartCamera = false;
    },

    snapImage(img) {
      // this.imgUpload = img;
      this.resizeImage(img);
      this.$bvModal.hide("modal-camera");

      this.fileName = this.dataURLtoFile(img, "snapshot.png");
      this.fileImageUpload = this.dataURLtoFile(img, "snapshot.png");
      this.imgUpload = this.fileImageUpload;
    },

    showModalAttachReference() {
      // this.imgUpload = null;

      this.$bvModal.show("modal-attach-reference");
    },

    dataURLtoFile(dataUrl, filename) {
      var arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    async uploadImage(data) {
      this.dataUploadDaily = data;
      //ไม่ได้อัพรูปมา
      if (this.fileImageUpload != null) {
        const headers = {
          Accept: "application/json",
          "Content-type": "application/json",
          Authorization: `Bearer ${store.state.token}`,
          "file-path": "ghg-lists",
        };

        const url = `${apiURL}/file`;

        let formData = new FormData();
        formData.append("file", this.fileImageUpload);

        try {
          const upload = await axios.post(url, formData, { headers: headers });
          if (upload.status == 200) {
            this.responseFileUpload = await upload.data;
            await this.saveDataDaily(data);
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        await this.saveDataDaily(data);
      }

      this.imgUpload = null;
    },

    showPicture(data) {
      this.picture =
        data.files && data.files.length > 0 ? data.files[0].file : null;
      this.$bvModal.show("modal-picture");
    },

    //upload image emit
    imageUpload(img) {
      this.fileImageUpload = img;
    },

    uploadImageEdit(data) {
      this.dataUploadDaily = data;
      // console.log('fileImageUpload',this.fileImageUpload);
      if (this.fileImageUpload == null) {
        //ไม่มีการอัพรูปใหม่
        this.editDataDaily(data);
      } else {
        this.editUploadImage(data);
      }
    },

    async editUploadImage(data) {
      const headers = {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${store.state.token}`,
        "file-path": "ghg-lists",
      };

      const url = `${apiURL}/file`;
      let formData = new FormData();
      formData.append("file", this.fileImageUpload);

      try {
        const upload = await axios.post(url, formData, { headers: headers });
        if (upload.status == 200) {
          this.responseFileUpload = await upload.data;
          await this.editDataDaily(data);
        }
      } catch (err) {
        console.log(err);
      }
    },

    resizeImage(img) {
      if (img) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          this.openImage(reader.result);
        });

        reader.readAsDataURL(this.base64ToBlob(img));
      }
    },

    openImage(imageSrc) {
      let canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      this.activeImage = new Image();
      this.activeImage.addEventListener("load", () => {
        let originalWidth = this.activeImage.width;
        let originalHeight = this.activeImage.height;
        let canvaWidth = 0;
        let canvaHeight = 0;

        if (originalWidth > originalHeight) {
          //รูปแนวนอน
          if (originalWidth > 1920) {
            canvaWidth = 1920;
            canvaHeight = 1080;
          } else {
            canvaWidth = originalWidth;
            canvaHeight = originalHeight;
          }
        } else {
          //รูปแนวตั้ง
          if (originalWidth > 1080) {
            canvaWidth = 1080;
            canvaHeight = 1920;
          } else {
            canvaWidth = originalWidth;
            canvaHeight = originalHeight;
          }
        }
        // set size proportional to image

        canvas.width = canvaWidth;
        canvas.height = canvaHeight;
        ctx.drawImage(this.activeImage, 0, 0, canvaWidth, canvaHeight);

        // let compressedImageBlob = null;

        canvas.toBlob(
          (blob) => {
            if (blob) {
              this.img = URL.createObjectURL(blob);
              // console.log('this.img',this.img);
              this.fileImageUpload = blob;
              // console.log("fileImageUpload", this.fileImageUpload);
            }
          },
          "image/png",
          1
        );
      });

      this.activeImage.src = URL.createObjectURL(this.base64ToBlob(imageSrc));
    },

    async deleteImage(list) {
      this.isDeleteImg = true;
      const url = `${apiURL}/measure_list_history`;
      const _data = {
        id: parseInt(list.id),
        amount: this.input_type == 0 ? list.amount : list.current_amount,
        file_ids: [],
      };

      try {
        const deleteImage = await httpClient.put(url, _data);
        if (deleteImage.status == 200) {
          this.getGhgLists();
          this.getHistory();
          this.$toast.success("บันทึกสำเร็จ");
        }
      } catch (err) {
        this.$toast.error(err.response.data.message);
      }
      this.isDeleteImg = false;
    },

    async getDateTimeFilledIn() {
      const url = `${apiURL}/measure_list_history/date_time/group?measure_list_id=${this.ghg_id}`;
      try {
        const date_time = await httpClient.get(url);
        this.date_time = date_time.data;
      } catch (err) {
        this.$toast.error({
          component: "styled-toast",
          props: {
            type: "error",
            message: err.response.data.message,
          },
        });
      }
    },
    confirmDeleteDetail(data) {
      this.data_row = data;
      this.text_header = "ลบการบันทึกข้อมูล";
      this.sub_text = `คุณกำลังจะลบการบันทึกข้อมูล ${this.monthTh(
        data.date
      )} ข้อมูลจะถูกลบอย่างถาวร คุณแน่ใจว่าต้องการลบหรือไม่`;
      this.$bvModal.show("modal-confirm");
    },
  },
};
</script>
<style lang="scss">
.modal-header {
  padding: 10px 15px;
}

.reset-box {
  border: 1px solid red;
  color: red;
}

.button-fillin {
  background: #1d273f;
  font-size: 16px !important;
  &:hover {
    background: lighten(#1d273f, 10%);
  }
}

.box-detail {
  padding: 16px;
  border-radius: 10px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  background: #fff;
}
</style>
